/**
 * SPA bootstrap (SSO-FRONTEND-LIT.md §1.2).
 *
 * - Initializes localization (URL prefix → stored culture) before the shell renders text.
 * - Registers and mounts `<sso-app>`, which owns the router outlet, branding bar, theme and locale.
 *
 * The shell itself re-asks the server "where am I?" via GET /api/session on boot, so this file
 * stays deliberately thin and holds no auth state.
 */
import { applyLocale, initialLocaleFromUrl } from './i18n/init.js';

// Side-effect import: defines the <sso-app> custom element.
import './app-root.js';

async function bootstrap(): Promise<void> {
  // Set the initial locale from the URL prefix the backend already uses (ARCHITECTURE §6.5).
  // The shell refines this from the user's stored culture once /api/session resolves.
  await applyLocale(initialLocaleFromUrl());

  // The shell element is declared in index.html (<sso-app>); nothing else to mount.
  // If it were not, we would: document.body.appendChild(document.createElement('sso-app'));
}

void bootstrap();
